export default function ArrowLeft() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.288 18.362C11.4755 18.1745 11.5808 17.9201 11.5808 17.6549C11.5808 17.3897 11.4755 17.1353 11.288 16.9478L7.33523 12.9951L19.0661 13.0021C19.3324 13.0021 19.5878 12.8964 19.7761 12.708C19.9644 12.5197 20.0702 12.2643 20.0702 11.998C20.0702 11.7317 19.9644 11.4764 19.7761 11.288C19.5878 11.0997 19.3324 10.994 19.0661 10.994L7.33523 11.001L11.288 7.0483C11.4755 6.86076 11.5808 6.60641 11.5808 6.34119C11.5808 6.07598 11.4755 5.82162 11.288 5.63409C11.1004 5.44655 10.8461 5.34119 10.5808 5.34119C10.3156 5.34119 10.0613 5.44655 9.87374 5.63409L4.21689 11.2909C4.02935 11.4785 3.92399 11.7328 3.92399 11.998C3.92399 12.2633 4.02935 12.5176 4.21689 12.7052L9.87374 18.362C10.0613 18.5495 10.3156 18.6549 10.5808 18.6549C10.8461 18.6549 11.1004 18.5495 11.288 18.362Z"
        fill="#808285"
      />
    </svg>
  );
}
